import { OrbitalTrackFilterData } from '@apeiron/orbital'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { orbitalTrackFilterDataSchema } from '@src/deserialize/yup/orbitalTrackFilter'

const useFetchOrbitalTrackFilterJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<OrbitalTrackFilterData>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.ORBIT_FILTERS,
    deserialize: response =>
      orbitalTrackFilterDataSchema.cast(response) as OrbitalTrackFilterData
  })
}

export default useFetchOrbitalTrackFilterJson
